export default __webpack_public_path__ + "static/Fellix-BoldItalic-28a58f9e05de36f637e9984a1e2cac18.otf";